import React from 'react';
import { useLanguage } from '@/i18n/context/LanguageContext';

interface TProps extends React.HTMLAttributes<HTMLSpanElement> {
  ru: string;
  en: string;
  tag?: keyof JSX.IntrinsicElements;
}

const T: React.FC<TProps> = ({ ru, en, className, tag = 'span', ...props }) => {
  const { language } = useLanguage();
  
  const content = language === 'ru' ? ru : en;
  
  return React.createElement(tag, { className, ...props }, content);
};

export default T;